/**
 * Created by Michael Pittner on 15.12.2016.
 */

function newAjaxWithParams(params_object, url, successListener, errorListener, async, method) {
    // TODO!
}

function newAjaxWithSuccessParams(url, successListener, successListener_params) {
    newAjax(url, successListener, undefined, undefined, undefined, undefined, successListener_params, false);
}

function replaceUrlSingleParameter(str) {
    str = str.replace('&', '%0A%26');
    str = str.replace(',', '%2C');
    str = str.replace(':', '%3A');
    str = str.replace('+', '%2B');
    str = str.replace(';', '%3B');
    str = str.replace('(', '%28');
    str = str.replace(')', '%29');

    return str;
}


function replaceUrlParams(str) {
    return encodeURI(str).replace(/%5B/g, '[').replace(/%5D/g, ']');
}

function newCancellingAjax(url, successListener, xmlhttp_operation) {
    return newAjax(url, successListener, undefined, undefined, undefined, undefined, undefined, undefined, xmlhttp_operation);
}

function newCancellingAjaxGetCheck(url, successListener, xhr) {
    return newAjax(url, successListener, undefined, undefined, "GET", undefined, undefined, undefined, xhr, true);
}

function newPostAjax(url, successListener, postObj) {
    var postObjForm = createAsForm(postObj);
    return newAjax(url, successListener, undefined, undefined, "POST", postObjForm);
}


/** Check & save functions (new) **/
function newAjaxCheckSaved(url, successListener, errorListener) {
    return newAjax(url, successListener, errorListener, undefined, undefined, undefined, undefined, undefined, undefined, true, true);
}

function newAjaxSaved(url, successListener) {
    return newAjax(url, successListener, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, true);
}

/** Check & save functions (new) **/
function newAjaxCheckSavedWithSuccessParams(url, successListener, success_params) {
    return newAjax(url, successListener, undefined, undefined, undefined, undefined, success_params, undefined, undefined, true, true);
}

function newPostAjaxCheckSaved(url, successListener, postObj) {
    var postObjForm = createAsForm(postObj);
    return newAjax(url, successListener, undefined, undefined, "POST", postObjForm, undefined, undefined, undefined, true, true);
}

function newPostAjaxCheckSavedFileDownload(url, successListener, postObj, xhr) {
    var postObjForm = createAsForm(postObj);
    return newAjax(url, successListener, undefined, undefined, "POST", postObjForm, undefined, undefined, undefined, true, true, true);
}

function newFormDataXHRSuccessParamsAjaxCheckSaved(url, successListener, postObj, xhr, success_params) {
    //var postObjForm = createAsForm( postObj );
    return newAjax(url, successListener, undefined, undefined, "POST", postObj, success_params, undefined, xhr, true, true);
}

function newPostAjaxWithParamsCheckSaved(url, successListener, postObj, params) {
    var postObjForm = createAsForm(postObj);
    return newAjax(url, successListener, undefined, undefined, "POST", postObjForm, params, undefined, undefined, true, true);
}

/** **/

/** only Check functions (new) **/
function newPostAjaxCheck(url, successListener, postObj) {
    var postObjForm = createAsForm(postObj);
    return newAjax(url, successListener, undefined, undefined, "POST", postObjForm, undefined, undefined, undefined, true, undefined);
}

function newPutAjaxCheck(url, successListener, postObj, xhr) {
    var postObjForm = createAsForm(postObj, "PUT");
    return newAjax(url, successListener, undefined, undefined, "PUT", postObjForm, undefined, undefined, xhr, true, undefined);
}

function newPutAjaxCheckSaved(url, successListener, postObj, xhr) {
    return newAjax(url, successListener, undefined, undefined, "PUT", JSON.stringify(postObj), undefined, undefined, xhr, true, true);
}

/** Check & save functions (new) **/
function newPutAjaxCheckSavedUrl(url, successListener) {
    return newAjax(url, successListener, undefined, undefined, "PUT", undefined, undefined, undefined, undefined, true, true);
}

function newAjaxCheck(url, successListener, xhr) {
    return newAjax(url, successListener, undefined, undefined, undefined, undefined, undefined, undefined, xhr, true, undefined);
}

function newAjaxCheckWithError(url, successListener, xhr, errorListener) {
    return newAjax(url, successListener, errorListener, undefined, undefined, undefined, undefined, undefined, xhr, true, undefined);
}

function newAjaxCheckWithParams(url, successListener, params) {
    return newAjax(url, successListener, undefined, undefined, undefined, undefined, params, undefined, undefined, true, undefined);
}

function newAjaxCheckDelete(url, successListener, xhr) {
    return newAjax(url, successListener, undefined, undefined, "DELETE", undefined, undefined, undefined, xhr, true, undefined);
}

class AjaxParameter {
    constructor(url) {
        this.successListener = undefined;
        this.errorListener = undefined;
        this.async = undefined;
        this.method = undefined;
        this.params = undefined;
        this.successListener_params = undefined;
        this.gzip = undefined;
        this.xmlhttp_operation = undefined;
        this.check_return = true;
        this.saved = undefined;
        this.url = url;
    }
}

function ajaxReq(ajaxParameterObject) {
    if (ajaxParameterObject === undefined || !(ajaxParameterObject instanceof AjaxParameter))
        return;
    return newAjax(ajaxParameterObject.url, ajaxParameterObject.successListener, ajaxParameterObject.errorListener, ajaxParameterObject.async, ajaxParameterObject.method,
        ajaxParameterObject.params, ajaxParameterObject.successListener_params, ajaxParameterObject.gzip, ajaxParameterObject.xmlhttp_operation, ajaxParameterObject.check_return, ajaxParameterObject.saved);

}

/**
 * Sends a request with the HTTP DELETE method
 * @param url
 * @param successListener
 * @returns {XMLHttpRequest}
 */
function newDeleteAjaxCheck(url, successListener) {
    return newAjax(url, successListener, undefined, undefined, "DELETE", undefined, undefined, undefined, undefined, true, undefined);
}

/**
 * Sends a request with the HTTP DELETE method and passes params to the success listener
 * @param url
 * @param successListener
 * @param params
 * @returns {XMLHttpRequest}
 */
function newAjaxCheckWithParamsnewDeleteAjaxCheckWithSucceslistenerParamss(url, successListener, params) {
    return newAjax(url, successListener, undefined, undefined, "DELETE", undefined, params, undefined, undefined, true, undefined);
}

function newDeleteAjaxWithPostParam(url, successListener, postObj) {
    var postObjForm = createAsForm(postObj);
    return newAjax(url, successListener, undefined, undefined, "DELETE", JSON.stringify(postObj), undefined, undefined, undefined, true, undefined);
}

function newPatchAjaxCheck(url, successListener) {
    return newAjax(url, successListener, undefined, undefined, "PATCH", undefined, undefined, undefined, undefined, true, undefined);
}

function newPatchAjaxCheckSaved(url, successListener, patchObj, xhr) {
    return newAjax(url, successListener, undefined, undefined, "PATCH", JSON.stringify(patchObj), undefined, undefined, xhr, true, true);
}

/** **/


const HTTPMETHOD = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
    PATCH: "PATCH"
}

/**
 *
 * @param url
 * @param successListener
 * @param errorListener
 * @param async true|false
 * @param method GET|POST
 * @param params ONLY RELEVANT ON POST!
 * @param successListener_params Parameter die direkt an den SuccessListener übergeben werden
 * @param gzip boolean
 * @param xmlhttp_operation
 * @param check_return
 * @param saved
 * @param fileDownload
 */
function newAjax(url, successListener, errorListener, async, method, params, successListener_params, gzip, xmlhttp_operation, check_return, saved, fileDownload = false) {

    if (async === undefined)
        async = true;
    if (method === undefined)
        method = "GET";
    if (errorListener === undefined)
        errorListener = ajaxNotSuccessError;
    if (gzip === undefined)
        gzip = false;


    //if (gzip === true) {
    // load /extern_modules/jscompress/jsxcompressor.min.js
    // $.getScript("/extern_modules/jscompress/jsxcompressor.min.js");
    //}

    if (window.XMLHttpRequest) {
        if (xmlhttp_operation === undefined) {
            xmlhttp_operation = new XMLHttpRequest();
        } else {
            if (xmlhttp_operation instanceof XMLHttpRequest) {
                // is ajax request
                if (xmlhttp_operation.readyState !== 4) {
                    // is not finished
                    xmlhttp_operation.abort();
                }

            } else {
                return;
            }
        }
    } else {
        return;
    }

    if (fileDownload === true)
        xmlhttp_operation.responseType = 'blob';

    xmlhttp_operation.onreadystatechange = function () {

        // HEADING of General-Error-Alert-Box
        let error_alert_input = "";
        if (document.getElementById("error_alert_input") !== null)
            error_alert_input = document.getElementById("error_alert_input");


        // HEADING of JSON-Error-Alert-Box
        let json_error_alert_heading = "";
        if (document.getElementById("ajax_json_error_heading") !== null)
            json_error_alert_heading = document.getElementById("ajax_json_error_heading").value;


        // Text of JSON-Error-Alert-Box
        let json_error_alert_txt = "";
        if (document.getElementById("ajax_json_error_text") !== null)
            json_error_alert_txt = document.getElementById("ajax_json_error_text").value;

        if (xmlhttp_operation.readyState === 4) {


            if (saved !== undefined && saved === true) {
                if (typeof finishedSaving == 'function')
                    finishedSaving();
            } else {
                if (typeof finishLoading == 'function')
                    finishLoading();
            }

            if (xmlhttp_operation.status === 0) {
                // Request was canceled
                return;
            }

            if (fileDownload === false) {
                var result = xmlhttp_operation.responseText;
                if (xmlhttp_operation.status !== 204 && validJson(result) === false) {
                    openAlert(json_error_alert_heading, json_error_alert_txt, ALERTTYPE.error);
                    return;
                }
            }

            let result_object;

            switch (xmlhttp_operation.status) {
                case 0:
                    // if ajax-request is cancelled, status is 0
                    return;
                case 204:
                    // no content
                    break;
                case 206: // used if dashboard element timeout
                case 200:
                case 201: // created
                case 202: // accepted


                    if (gzip === true) {
                        result = JXG.decompress(result);
                    }

                    if (fileDownload === true) {
                        var blob = new Blob([this.response], {type: 'application/vnd.ms-excel'});
                        //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
                        let a = document.createElement("a");
                        a.style = "display: none";
                        document.body.appendChild(a);
                        //Create a DOMString representing the blob and point the link element towards it
                        let url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = xmlhttp_operation.getResponseHeader("filename")
                        //programatically click the link to trigger the download
                        a.click();
                        //release the reference to the file by revoking the Object URL
                        window.URL.revokeObjectURL(url);

                        return;
                    }

                    result_object = JSON.parse(result);
                    result_object.success = parseInt(result_object.success);
                    result_object.successListener_params = successListener_params;
                    if (check_return === true) {
                        if (parseInt(result_object.success) !== 1 && parseInt(result_object.success) !== 2) {
                            openAlert(error_alert_input.value, result_object.msg, ALERTTYPE.error);
                            return;
                        }
                    }
                    if (successListener !== undefined && typeof successListener === "function")
                        successListener(result_object, xmlhttp_operation.status);
                    break;
                case 401: // Die Anfrage kann nicht ohne gültige Authentifizierung durchgeführt werden. Wie die Authentifizierung durchgeführt werden soll, wird im „WWW-Authenticate“-Header-Feld der Antwort übermittelt.
                case 409:
                    result_object = JSON.parse(xmlhttp_operation.responseText);
                    let t = "Daten wurden inzwischen geändert, bitte lade die Seite neu!";
                    if (result_object.msg !== undefined)
                        t = result_object.msg;
                    openAlert(error_alert_input.value, t, ALERTTYPE.error);
                    if (errorListener !== ajaxNotSuccessError)
                        errorListener(result_object);
                    break;
                case 404: // Not found
                    result_object = JSON.parse(xmlhttp_operation.responseText);
                    openAlert("Unbekannter Fehler", result_object.msg, ALERTTYPE.error);
                    break;

                case 208: // Already Reported
                case 400: // Bad Request / Die Anfrage-Nachricht war fehlerhaft aufgebaut.
                case 403: // Forbidden
                case 406: // Not Acceptable / Die Anfrage-Nachricht wird nicht akzeptiert.
                case 415: // Unsupported Media Type / Der Inhalt der Anfrage wurde mit ungültigem oder nicht erlaubtem Medientyp übermittelt.
                case 422: // Unprocessable Entity / Verwendet, wenn weder die Rückgabe von Statuscode 415 noch 400 gerechtfertigt wäre, eine Verarbeitung der Anfrage jedoch zum Beispiel wegen semantischer Fehler abgelehnt wird.
                    result_object = JSON.parse(xmlhttp_operation.responseText);
                    openAlert(error_alert_input.value, result_object.msg, ALERTTYPE.error);
                    if (errorListener !== ajaxNotSuccessError)
                        errorListener(result_object);

                    break;
                case 421: // logged out
                    redirect("/Login");
                    break;
                case 500: // Server error
                    result_object = JSON.parse(xmlhttp_operation.responseText);
                    openAlert("Unbekannter Fehler", result_object.msg, ALERTTYPE.error);
                    break;
                case 501: // Not Implemented => GET, POST, ... falsch!
                    //result_object = JSON.parse(xmlhttp_operation.responseText);
                    openAlert("Bad-Method", "Wrong method used!", ALERTTYPE.error);
                    break;
                case 554: // Server error
                    result_object = JSON.parse(xmlhttp_operation.responseText);
                    openAlert("Ladezeitüberschreitung", result_object.msg, ALERTTYPE.error);
                    break;
                case 408: // Server error
                    result_object = JSON.parse(xmlhttp_operation.responseText);
                    openAlert("Ladezeitüberschreitung", result_object.msg, ALERTTYPE.error);
                    break;
                case 555: // Server error
                    result_object = JSON.parse(xmlhttp_operation.responseText);
                    openAlert("Unbekannter Fehler", result_object.msg, ALERTTYPE.error);
                    break;
                case 503: // Server error
                    result_object = JSON.parse(xmlhttp_operation.responseText);
                    openAlert("Service Unavailable", result_object.msg, ALERTTYPE.error);
                    break;
                default:
                    openAlert(error_alert_input.value, "Undefined error! (http-error-code not found)", ALERTTYPE.error);
            }
        }
    };
    xmlhttp_operation.open(method, url, async);
    // console.log(url);
    if (typeof initLoading == 'function')
        initLoading();
    if (saved && typeof initFullScreenSaving == 'function')
        initFullScreenSaving();
    if (method.toUpperCase() === "POST" || method.toUpperCase() === "PUT" || method.toUpperCase() === "PATCH" ||
        method.toUpperCase() === "DELETE") {
        //Send the proper header information along with the request
        //xmlhttp_operation.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        if (method.toUpperCase() === "PUT" || method.toUpperCase() === "PATCH" || method.toUpperCase() === "DELETE")
            if (isJsonString(params))
                xmlhttp_operation.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
        xmlhttp_operation.send(params);
    } else if (method.toUpperCase() === "JSONPOST" ) {
        xmlhttp_operation.open("POST", url, async);
        xmlhttp_operation.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
        xmlhttp_operation.send(JSON.stringify(params));
    } else {
        xmlhttp_operation.send();
    }
    return xmlhttp_operation;
}

function createAsForm(obj, method = "POST") {
    var form = document.createElement("form");
    form.setAttribute("method", method);
    if (obj !== undefined) {
        for (var key in obj) {
            let val = obj[key];
            // skip loop if the property is from prototype
            if (!obj.hasOwnProperty(key)) continue;
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            if (Array.isArray(val))
                val = JSON.stringify(val);

            hiddenField.setAttribute("value", val);
            form.appendChild(hiddenField);
        }
    }
    return new FormData(form);
}

function ajaxNotSuccessError(xmlhttp) {
    openAlert("AJAX-Error", "Ajax-Response: " + xmlhttp.status, 1);
}

function validJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}